import { useState } from 'react';
import {
  usePharmacyStorageRacks,
  useCreatePharmacyStorageRack,
  useUpdatePharmacyStorageRack,
  useDeletePharmacyStorageRack,
} from '../../services/httpServices/queries';
import { PharmacyLookupPage } from './PharmacyLookupPage';
import { LayoutGrid } from 'lucide-react';
import type { CreateLookupDto } from '../../services/httpServices/pharmacyDrugService';

export function PharmacyRacks() {
  const [search, setSearch] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [editingItem, setEditingItem] = useState<any>(null);
  const [formData, setFormData] = useState<CreateLookupDto>({ name: '', location: '', description: '', isActive: true });

  const { data, isLoading, error } = usePharmacyStorageRacks();
  const createMutation = useCreatePharmacyStorageRack();
  const updateMutation = useUpdatePharmacyStorageRack();
  const deleteMutation = useDeletePharmacyStorageRack();

  const items = data?.data || [];

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (editingItem) {
      await updateMutation.mutateAsync({ id: editingItem.id, data: formData });
    } else {
      await createMutation.mutateAsync(formData);
    }
    setModalOpen(false);
    setFormData({ name: '', location: '', description: '', isActive: true });
  };

  const handleDelete = async (id: string) => {
    await deleteMutation.mutateAsync(id);
  };

  return (
    <PharmacyLookupPage
      title="Storage Racks"
      description="Manage physical storage locations of medicines in the pharmacy"
      icon={LayoutGrid}
      items={items}
      isLoading={isLoading}
      error={error}
      search={search}
      setSearch={setSearch}
      modalOpen={modalOpen}
      setModalOpen={setModalOpen}
      editingItem={editingItem}
      setEditingItem={setEditingItem}
      formData={formData}
      setFormData={setFormData}
      onSubmit={handleSubmit}
      onDelete={handleDelete}
      isSubmitting={createMutation.isPending || updateMutation.isPending}
      isDeleting={deleteMutation.isPending}
      extraFields={[
        { name: 'location', label: 'Location', placeholder: 'e.g. Ground floor, east wing' },
        { name: 'description', label: 'Description', type: 'textarea', placeholder: 'Optional description' },
      ]}
    />
  );
}
